export { default as NunitoBlack } from 'public/fonts/nunito/NunitoSans-Black.ttf';
export { default as NunitoBold } from 'public/fonts/nunito/NunitoSans-Bold.ttf';
export { default as NunitoExtraBold } from 'public/fonts/nunito/NunitoSans-ExtraBold.ttf';
export { default as NunitoExtraLight } from 'public/fonts/nunito/NunitoSans-ExtraLight.ttf';
export { default as NunitoLight } from 'public/fonts/nunito/NunitoSans-Light.ttf';
export { default as NunitoRegular } from 'public/fonts/nunito/NunitoSans-Regular.ttf';
export { default as NunitoSemiBold } from 'public/fonts/nunito/NunitoSans-SemiBold.ttf';
